import type { Page } from '../../types';

const minStandardFinance: Page[] = [
  {
    pageType: 'question',
    title: 'Minimum Standards',
    name: 'minimum-standards',
    hidePageTitle: true,
    description:
      'A conversation must take place at the start of the year between you and your Line Manager to agree how these standards will be demonstrated in a way that is relevant to your role. You should agree how you will determine whether you have \'met\' these standards. The standards can be found here <a href="https://www.gov.uk/government/publications/senior-civil-service-performance-management" target="_blank" rel="noopener noreferrer">gov.uk</a>. Line Managers will make judgements on whether standards have been met as part of their validation.<br><br>Please complete the box below on how you have met each of the Minimum Standards. Please refer to evidence captured throughout the performance year<br><br>',
    questions: [
      {
        questionType: 'textarea',
        textRows: 20,
        title: 'Finance',
        name: 'minimum-standard-finance',
        detailsHeading: 'More information',
        detailsContent: `The minimum finance standards require all SCS to:<br><ul>
  <li>Manage public money and other resources in line with the principles in <a href="https://www.gov.uk/government/publications/managing-public-money" target="_blank" rel="noopener noreferrer">Managing Public Money guidance</a>, and ensure adherence with any relevant spending controls.</li>
  <li>Continually seek opportunities for efficiency and consider value for money for the taxpayer in all decision-making.</li>
  <li>Where necessary, take difficult decisions to make appropriate trade-offs to benefit the organisation and/or Civil Service as a whole.</li>
</ul>`,
        hint: `How will this be demonstrated in my role?  
  • Budgetary responsibilities: type (e.g. admin/capital/programme), value and description (what is the budget for).`,
        wordCount: 250,
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default minStandardFinance;
